import React, { memo } from "react"
import PropTypes from "prop-types"
import AddRoleModal from "./AddRoleModal"
import EditRoleModal from "./EditRoleModal"
import DeleteRoleWithReassignModal from "./DeleteRoleWithReassignModal"

const RoleModals = ({
  isAddRoleModalOpen,
  isEditRoleModalOpen,
  isDeleteRoleModalOpen,
  editingRole,
  deletingRole,
  deletionCheckData,
  assignedStaffForRole,
  availableRoles,
  onCloseAddModal,
  onCloseEditModal,
  onCloseDeleteModal,
  onSaveNewRole,
  onSaveEditRole,
  onConfirmDelete
}) => {
  return (
    <>
      <AddRoleModal open={isAddRoleModalOpen} onCancel={onCloseAddModal} onSave={onSaveNewRole} />
      <EditRoleModal open={isEditRoleModalOpen} onCancel={onCloseEditModal} onSave={onSaveEditRole} roleData={editingRole} />
      <DeleteRoleWithReassignModal
        open={isDeleteRoleModalOpen}
        onCancel={onCloseDeleteModal}
        onConfirm={onConfirmDelete}
        roleName={deletingRole?.name}
        assignedStaff={deletionCheckData?.staff_members || assignedStaffForRole}
        availableRoles={deletionCheckData?.available_roles || availableRoles}
      />
    </>
  )
}

RoleModals.propTypes = {
  isAddRoleModalOpen: PropTypes.bool.isRequired,
  isEditRoleModalOpen: PropTypes.bool.isRequired,
  isDeleteRoleModalOpen: PropTypes.bool.isRequired,
  editingRole: PropTypes.object,
  deletingRole: PropTypes.object,
  deletionCheckData: PropTypes.object,
  assignedStaffForRole: PropTypes.array.isRequired,
  availableRoles: PropTypes.array.isRequired,
  onCloseAddModal: PropTypes.func.isRequired,
  onCloseEditModal: PropTypes.func.isRequired,
  onCloseDeleteModal: PropTypes.func.isRequired,
  onSaveNewRole: PropTypes.func.isRequired,
  onSaveEditRole: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired
}

export default memo(RoleModals)
